import {
  cycleCountIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { taskIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

const AssignedCycleCount = z.object({
  cycleCountId: cycleCountIdFormat.schema,
  taskId: taskIdFormat.schema,
  name: z.string().nullable(),
  locationId: locationIdFormat.schema,
  status: z.enum(["todo", "in_progress"]),
  /** Matches the inventory app's naming: a count walks items or bins. */
  targetType: z.enum(["items", "bins"]),
  dueAt: z.date().nullable(),
  /** Plan rows finished over plan rows total, so progress survives a reload. */
  totalUnits: z.int(),
  countedUnits: z.int(),
});

export const listAssignedCycleCounts = {
  name: "listAssignedCycleCounts" as const,
  input: z.object({ locationId: locationIdFormat.schema }),
  output: z.object({
    /** Counts this user already holds. */
    mine: z.array(AssignedCycleCount),
    /** Assigned to a role the user has and not yet claimed by anyone. */
    claimable: z.array(AssignedCycleCount),
  }),
};
